// project imports
import { extendPaletteWithChannels } from 'utils/colorUtils';

// assets
import defaultColor from './theme/default';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette(presetColor) {
  let colors;
  switch (presetColor) {
    case 'default':
    default:
      colors = defaultColor;
  }

  const lightColors = {
    primary: {
      light: colors.primaryLight,
      main: colors.primaryMain,
      dark: colors.primaryDark,
      200: colors.primary200,
      800: colors.primary800
    },
    secondary: {
      light: colors.secondaryLight,
      main: colors.secondaryMain,
      dark: colors.secondaryDark,
      200: colors.secondary200,
      800: colors.secondary800
    },
    error: {
      light: colors.errorLight,
      main: colors.errorMain,
      dark: colors.errorDark
    },
    orange: {
      light: colors.orangeLight,
      main: colors.orangeMain,
      dark: colors.orangeDark
    },
    warning: {
      light: colors.warningLight,
      main: colors.warningMain,
      dark: colors.warningDark,
      contrastText: colors.grey700
    },
    success: {
      light: colors.successLight,
      200: colors.success200,
      main: colors.successMain,
      dark: colors.successDark
    },
    grey: {
      50: colors.grey50,
      100: colors.grey100,
      500: colors.grey500,
      600: colors.grey600,
      700: colors.grey700,
      900: colors.grey900
    },
    dark: {
      light: colors.darkTextPrimary,
      main: colors.darkLevel1,
      dark: colors.darkLevel2,
      800: colors.darkBackground,
      900: colors.darkPaper
    },
    text: {
      primary: '#1e293b',
      secondary: '#1e293b',
      dark: '#1e293b',
      hint: '#64748b',
      heading: '#1e293b'
    },
    divider: colors.grey200,
    background: {
      paper: colors.paper,
      default: colors.paper
    },
    chart: {
      teal: colors.primaryDark,
      amber: colors.secondaryMain,
      danger: '#e11d48',
      muted: colors.grey500,
      grid: colors.grey200
    }
  };

  const commonColor = { common: { black: colors.darkPaper, white: '#fff' } };
  
  const darkColors = {
    primary: {
      light: colors.darkPrimaryLight,
      main: colors.darkPrimaryMain,
      dark: colors.darkPrimaryDark,
      200: colors.darkPrimary200,
      800: colors.darkPrimary800
    },
    secondary: {
      light: colors.darkSecondaryLight,
      main: colors.darkSecondaryMain,
      dark: colors.darkSecondaryDark,
      200: colors.darkSecondary200,
      800: colors.darkSecondary800
    },
    error: {
      light: 'rgba(248, 113, 113, 0.12)',
      main: colors.darkError,
      dark: '#DC2626'
    },
    orange: {
      light: colors.darkSecondaryLight,
      main: colors.darkSecondaryMain,
      dark: colors.darkSecondaryDark
    },
    warning: {
      light: 'rgba(251, 191, 36, 0.12)',
      main: colors.darkWarning,
      dark: '#D97706',
      contrastText: colors.darkCanvas
    },
    success: {
      light: 'rgba(52, 211, 153, 0.12)',
      200: '#6EE7B7',
      main: colors.darkSuccess,
      dark: '#059669'
    },
    info: {
      light: 'rgba(96, 165, 250, 0.12)',
      main: colors.darkInfo,
      dark: '#2563EB'
    },
    grey: {
      50: colors.darkLevel1,
      100: colors.darkLevel2,
      500: colors.darkTextSecondary,
      600: colors.darkTextPlaceholder,
      700: colors.darkTextPrimary,
      900: colors.darkBackground
    },
    dark: {
      light: colors.darkTextPrimary,
      main: colors.darkLevel1,
      dark: colors.darkLevel2,
      800: colors.darkBackground,
      900: colors.darkPaper
    },
    text: {
      primary: colors.darkTextPrimary,
      secondary: colors.darkTextSecondary,
      dark: colors.darkCanvas,
      hint: colors.darkTextPlaceholder,
      disabled: colors.darkTextDisabled,
      heading: colors.darkTextTitle
    },
    divider: colors.darkBorder,
    border: {
      default: colors.darkBorder,
      strong: colors.darkBorderStrong
    },
    background: {
      paper: colors.darkPaper,
      default: colors.darkBackground,
      canvas: colors.darkCanvas,
      card: colors.darkCard,
      raised: colors.darkRaised,
      header: colors.darkHeader,
      sidebar: colors.darkSidebar,
      input: colors.darkInput,
      hover: colors.darkHover
    },
    chart: {
      teal: colors.darkPrimary200,
      amber: colors.darkSecondaryMain,
      danger: colors.darkError,
      muted: '#64748B',
      grid: colors.darkChartGridlines
    }
  };

  const extendedLight = extendPaletteWithChannels(lightColors);
  const extendedDark = extendPaletteWithChannels(darkColors);
  const extendedCommon = extendPaletteWithChannels(commonColor);

  return {
    light: {
      mode: 'light',
      ...extendedCommon,
      ...extendedLight
    },
    dark: {
      mode: 'dark',
      ...extendedCommon,
      ...extendedDark
    }
  };
}
